module.exports = __webpack_public_path__ + "static/nxrt-automotive4-898974843c9d7fbb0756e19a17821746.jpg";